import React from "react";

const TestPostBackIcons = ({ height = 24, width = 24, color = "#000" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.625 24.1668V10.5126C3.28264 10.2911 2.99546 10.0091 2.76346 9.66675C2.53146 9.32439 2.41586 8.92161 2.41667 8.45842V4.83342C2.41667 4.16883 2.6535 3.59971 3.12717 3.12604C3.60084 2.65237 4.16956 2.41594 4.83334 2.41675H24.1667C24.8313 2.41675 25.4004 2.65358 25.874 3.12725C26.3477 3.60092 26.5841 4.16964 26.5833 4.83342V8.45842C26.5833 8.92161 26.4673 9.32439 26.2353 9.66675C26.0033 10.0091 25.7166 10.2911 25.375 10.5126V24.1668C25.375 24.8313 25.1382 25.4005 24.6645 25.8741C24.1908 26.3478 23.6221 26.5842 22.9583 26.5834H6.04167C5.37709 26.5834 4.80796 26.3466 4.33429 25.8729C3.86063 25.3993 3.6242 24.8305 3.625 24.1668ZM6.04167 10.8751V24.1668H22.9583V10.8751H6.04167ZM24.1667 8.45842V4.83342H4.83334V8.45842H24.1667ZM10.5 19L14 20.9168L19.5 15V12.5L14 18.5001L10.5 17V19Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default TestPostBackIcons;
